import { computed, defineComponent, ref } from '@vue/composition-api';
import ClickOutside from '@/directives/ClickOutside';
import Tooltip from '@/mixins/tooltip';
import DpDropdown from '../dropdown/Dropdown.vue';
import DpIcon from '../icon/Icon.vue';
import DpInput from '../input/Input.vue';
import DpSpinnerLoader from '../loader/SpinnerLoader.vue';
import DpVirtualOption from './VirtualOption.ts.vue';
export default defineComponent({
    name: 'DpVirtualSelect',
    directives: { ClickOutside },
    components: {
        DpIcon,
        DpInput,
        DpSpinnerLoader,
        DpDropdown,
        DpVirtualOption,
    },
    mixins: [Tooltip],
    props: {
        options: { type: Array, default: () => [] },
        value: { type: null, default: null },
        disabled: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        placeholder: { type: String, default: 'Select an option' },
        size: { type: String, default: 'default' },
        clearable: { type: Boolean, default: false },
        fullWidth: { type: Boolean, default: false },
        filterable: { type: Boolean, default: false },
        minWidth: { type: Number, default: null },
    },
    setup(props, { emit }) {
        const { value, options } = props;
        const virtualList = ref(null);
        const isOpen = ref(false);
        const openDropdown = () => {
            isOpen.value = true;
        };
        const closeDropdown = () => {
            isOpen.value = false;
        };
        const current = computed(() => {
            if (!value) {
                return {
                    text: props.placeholder,
                    isPlaceholder: true,
                    icon: null,
                };
            }
            return {
                text: value,
                isPlaceholder: false,
                icon: null,
            };
        });
        const onClickCurrent = () => {
            if (!isOpen.value) {
                openDropdown();
            }
            else {
                closeDropdown();
            }
        };
        const onClear = () => {
            emit('clear');
        };
        const filterText = ref('');
        const currentOptions = computed(() => options);
        // const selectOption = (option: DropdownOption): void => {};
        const selectOption = () => 1;
        const isFocused = ref(false);
        const onFocus = () => {
            isFocused.value = true;
        };
        const onBlur = () => {
            isFocused.value = false;
        };
        return {
            virtualList,
            isOpen,
            openDropdown,
            closeDropdown,
            current,
            onClickCurrent,
            onClear,
            filterText,
            currentOptions,
            selectOption,
            isFocused,
            onFocus,
            onBlur,
        };
    },
});
